import { NgClass } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModalComponent } from '../modal/tooltip-modal/tooltip-modal.component';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [NgClass, TranslateModule, TooltipModalComponent],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss'
})
export class TooltipComponent implements AfterViewInit {
  @ViewChild('tooltipText') tooltipText!: ElementRef;
  @ViewChild('tooltipButton') tooltipButton!: ElementRef;
  @ViewChild('lnaTooltip') lnaTooltip!: ElementRef;
  @Input() withMargin: boolean = false;
  @Input() marginBottom: boolean = false;
  @Input() text: string = '';
  @Input() position: string = 'top';
  isClamped: boolean = false;
  isOpen: boolean = false;
  isModalOpen: boolean = false;

  openTooltip(): void {
    this.isOpen = !this.isOpen;
  }

  ngAfterViewInit() {
    const button = this.tooltipButton.nativeElement;
    const onShow = () => {
      // Measure synchronously (the :hover/:focus styles are already applied when the show
      // events fire) and re-check on the next frame in case the bubble wasn't laid out yet.
      this.adjustBubbleHeight();
      requestAnimationFrame(() => this.adjustBubbleHeight());
    };
    button.addEventListener('mouseenter', onShow);
    button.addEventListener('focus', onShow);
  }

  // Let the text take as many lines as it needs, and only cut it when the bubble would
  // leave the viewport (LNA-2004). Shrinking the text pulls the bubble back in: every
  // position variant anchors it either by its bottom edge (above the icon) or its top
  // edge (below the icon), so the free edge is the one that moves.
  private adjustBubbleHeight(): void {
    const bubble = this.lnaTooltip?.nativeElement as HTMLElement | undefined;
    const text = this.tooltipText?.nativeElement as HTMLElement | undefined;
    if (!bubble || !text) return;
    text.style.maxHeight = '';
    const rect = bubble.getBoundingClientRect();
    if (rect.height) {
      const margin = 16;
      const minTextHeight = 66; // three lines at the 22px line height
      const overflow = Math.max(margin - rect.top, rect.bottom - (window.innerHeight - margin), 0);
      if (overflow > 0) {
        text.style.maxHeight = `${Math.max(text.clientHeight - overflow, minTextHeight)}px`;
      }
    }
    this.isClamped = text.scrollHeight > text.clientHeight;
  }
}
